import { CardHeader } from 'foundations-components/transitional/components/Card';
import { CustomToolbar } from './CardToolbarActions/CustomToolbar';
import Toolbar from './CardToolbarActions/Toolbar';
import { ReportCardHeaderTitle } from './ReportCardHeaderTitle';
import { ADD_ONS } from './constants/ReportCardOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReportCardHeader({
  header,
  subheader,
  description,
  reportActions,
  additionalReportActions,
  addOns,
  appUsageTracker,
  report,
  reportResolve,
  setIsReportViewerIsOpen,
  isReportActionsDisabled,
  onClickViewSRVAction,
  ToolbarOverride
}) {
  return /*#__PURE__*/_jsx(CardHeader, {
    "data-test-id": "report-card-v2--card-header",
    titleSize: addOns.includes(ADD_ONS.COMPACT_CARD) ? 'small' : 'medium',
    margin: "0",
    padding: "0",
    paddingBlockEnd: addOns.includes(ADD_ONS.COMPACT_CARD) || !!subheader ? '0' : '300',
    title: /*#__PURE__*/_jsx(ReportCardHeaderTitle, {
      header: header,
      description: description
    }),
    toolbar: ToolbarOverride || (report ? /*#__PURE__*/_jsx(Toolbar, {
      appUsageTracker: appUsageTracker,
      reportActions: reportActions,
      additionalReportActions: additionalReportActions,
      report: report,
      reportResolve: reportResolve,
      setIsReportViewerIsOpen: setIsReportViewerIsOpen,
      addOns: addOns,
      isReportActionsDisabled: isReportActionsDisabled,
      onClickViewSRVAction: onClickViewSRVAction
    }) : /*#__PURE__*/_jsx(CustomToolbar, {
      additionalReportActions: additionalReportActions,
      isReportActionsDisabled: isReportActionsDisabled
    }))
  });
}